import React from 'react';
import Type from 'prop-types';
import { Field, Form, useFormikContext } from 'formik';
import { Button, Typography } from '@mui/material';
import { TextField } from 'formik-mui';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useTranslation } from 'hooks';
import { useContacts, useContracts } from 'hooks/api/cascade';
import {
  SimpleAutocomplete,
  CurrencyField,
  FormattedNumber,
  PhoneField,
} from 'components';
import ContactPersonField from '../ContactPersonField';
import styles from './PromiseForm.module.css';

const PromiseForm = (props) => {
  const { entityId } = props;
  const { isLoading: isContactsLoading, data: contacts } =
    useContacts(entityId);
  const { isLoading: isContractsLoading, data: contracts } =
    useContracts(entityId);
  const { t } = useTranslation();
  const { setFieldValue, isSubmitting } = useFormikContext();

  const handleContractChange = (event, newValue) => {
    setFieldValue('contract', newValue);
    setFieldValue('amount', newValue.openDebt);
  };
  return (
    <Form noValidate>
      <Field
        id="contract"
        name="contract"
        component={SimpleAutocomplete}
        getOptionLabel={(option) => option.contract}
        options={contracts}
        fullWidth
        onChange={handleContractChange}
        loading={isContractsLoading}
        TextFieldProps={{
          label: t('contract'),
          required: true,
        }}
        renderOption={(optionProps, option) => (
          <li {...optionProps} key={option.contract}>
            <Typography variant="body1">{option.contract}</Typography>
            <Typography sx={{ml: 2}} component="span">
              {`${t('pdz')}: `}
            </Typography>
            <FormattedNumber
              component="span"
              value={option.openDebt}
              variant="body2"
              color="textSecondary"
              options={{
                currency: 'RUB',
                style: 'currency',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }}
            />
          </li>
        )}
      />

      <ContactPersonField options={contacts} loading={isContactsLoading} />

      <Field
        name="phone"
        component={PhoneField}
        type="tel"
        label={t('phone')}
        mask="+7 999 999-99-99"
        autoComplete="off"
        margin="normal"
        fullWidth
        required
      />

      <Field
        name="amount"
        label={t('amount')}
        component={CurrencyField}
        margin="normal"
        placeholder={t('enterPromisedAmount')}
        options={{
          currency: 'RUB',
        }}
        fullWidth
        required
      />

      <Field name="due" required>
        {({ field, form }) => (
          <DatePicker
            label={t('due')}
            value={field.value}
            onChange={(value) => form.setFieldValue(field.name, value)}
            slotProps={{
              textField: {
                variant: 'outlined',
                fullWidth: true,
                margin: 'normal',
              },
            }}
          />
        )}
      </Field>

      <Field
        name="comment"
        component={TextField}
        label={t('comment')}
        margin="normal"
        rowsMax={4}
        multiline
        fullWidth
        required
      />

      <div className={styles.buttonsWrapper}>
        <Button type="submit" color="primary" disabled={isSubmitting}>
          {t('save')}
        </Button>
      </div>
    </Form>
  );
};

PromiseForm.propTypes = {
  entityId: Type.string.isRequired,
};

export default PromiseForm;
